import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <Switch>
        <Route exact component={Home} path="/" />
        <Route component={Contact} path="/contact" />
      </Switch>
    </Router>
  );
};
export default App;
